import { Auth } from '@aws-amplify/auth';
import ApolloClient from 'apollo-client';

export interface AuthRefreshOptions {
    forceRefresh?: boolean;
}

export function getSessionUserGroups(session: any): string[] {
    const groups = session.getIdToken().payload['cognito:groups'];
    return Array.isArray(groups) ? groups.filter(group => typeof group === 'string') : [];
}

/** Keep UI permissions tied to the current session, never a persisted Apollo result. */
export async function loadAuthenticatedUser(
    client: ApolloClient<any>,
    { forceRefresh = false }: AuthRefreshOptions = {},
    canApply = () => true
): Promise<any> {
    const user = await Auth.currentAuthenticatedUser({ bypassCache: true });
    let session = await Auth.currentSession();

    if (forceRefresh) {
        // bypassCache refreshes attributes, but an unexpired JWT still has its old groups.
        session = await new Promise<typeof session>((resolve, reject) => {
            user.refreshSession(session.getRefreshToken(), (error, refreshedSession) => {
                if (error) reject(error);
                else resolve(refreshedSession);
            });
        });
    }

    if (canApply()) {
        client.writeData({ data: { userGroups: getSessionUserGroups(session) } });
    }
    return user;
}

export async function signOutAndClearPermissions(client: ApolloClient<any>): Promise<void> {
    await Auth.signOut();
    // clearStore avoids refetching authenticated queries after Cognito has signed out.
    await client.clearStore();
    client.writeData({ data: { userGroups: [] } });
}
